import React from 'react';
import getBaseTitle from './getBaseTitle';

const getCollectionTitle = ({ confirmedData, rootCollectionId = '' }) => {
  if (!confirmedData?.value?.length || !confirmedData?.operator) return '';

  const valueCount = confirmedData.value.length;

  const getValueText = (item) => (rootCollectionId === item._id && valueCount === 1 ? 'Collection' : item?.name || item?.title || item);

  const renderMultipleValues = () => (
    <>
      <span className="searchFilterItem__subtitle">
        {getBaseTitle({
          text: getValueText(confirmedData.value[0]),
          operator: confirmedData.operator,
          isSingle: false,
        })}
      </span>
      &nbsp;
      {confirmedData.operator === 'oneOf' ? 'or' : 'and'}
      &nbsp;
      <span>{`+${valueCount - 1}`}</span>
    </>
  );

  const renderSingleValue = () => (
    <span className="searchFilterItem__subtitle">
      {getBaseTitle({
        text: confirmedData.value.map(getValueText).join(', '),
        operator: confirmedData.operator,
        isSingle: true,
      })}
    </span>
  );

  return valueCount > 1 ? renderMultipleValues() : renderSingleValue();
};

export default getCollectionTitle;
